import { useQuoteI18n } from '../quoteI18n'

/**
 * Intestazione della pagina preventivo.
 *
 * @param {Object} props
 * @param {Object} [props.data] - Record del preventivo (anche nella versione bloccata)
 */
export function QuoteHeader({ data }) {
  const { t, locale } = useQuoteI18n()
  const expiresAt = data?.expiresAt ? new Date(data.expiresAt) : null

  return (
    <header className="gq-header">
      <div className="gq-header__mark" aria-hidden="true">
        N
      </div>
      <div>
        <h1 className="gq-header__title">{t.header.title}</h1>
        <p className="gq-header__subtitle">{t.header.subtitle}</p>
      </div>

      {expiresAt && (
        <div className="gq-header__meta">
          {t.header.validUntil}{' '}
          {expiresAt.toLocaleDateString(locale, {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
          })}
          <br />
          {t.header.atHour}{' '}
          {expiresAt.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' })}
        </div>
      )}
    </header>
  )
}
